import { fetchJSON } from '@bonnet/next/fetch';

const options = {
    credentials: 'omit',
    headers: {
        'X-fwd-svc': 'atc',
        'Content-Type': 'application/json',
    },
    circuitBreaker: {
        id: 'listingsAgent',
        timeout: 70000, // proxy timeout is 60s, so set this higher
        resetTimeout: 100000,
        fallback: {},
    },
};

export default ({ message, sessionContext = [] }) => fetchJSON('/agent', {
    ...options,
    body: {
        message,
        sessionContext,
    },
    method: 'POST',
});
